/*
* @requires  reader-websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    var loadingImg = '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'

    /**
     * 新建阅读器
     * @param param
     * {
     *     divId: 贴合网页div的id。如果设置则阅读器贴合到这个div上，如果不设置，则不贴合。
     *     context: 签章环境
     *     success：function(reader){}
     *     fail: function(e){}
     * }
     */
    function Reader(param) {
        this.imp=new $m.ReaderWebsocket(param,this,this._eventHandler);
        //this.imp.setEventCallback(this,null);

        this.context=param.context;
        this.divReaderContainer=param.divId

        this.nAppletRunID = 0;       // 0：无需贴合；非0：贴合
        this.bRunInCurrentPage = true;		// 是否为当前页面加载的程序
        this.lastPos={ x: 0, y: 0, w: 0, h: 0, isMax: false, nshow: 4 };
        this.timerScroll=null;        // 定时器检测窗口位置
        this.readerId=""
        this.status="notOpen"
        this.pendingScroll=null
        this.eventBus={};

        this._initListeners()
    }

    Reader.STATUS_OPENED = "opened"    //阅读器已打开
    Reader.STATUS_NOT_OPEN = "notOpen"  //阅读器未打开
    Reader.STATUS_OPENING = "opening"  //阅读器打开中
    Reader.STATUS_CLOSING = "closing"   //阅读器关闭中

    /**
     * 打开阅读器
     * @param param
     * {
     *     file:  阅读器打开的文件路径，如果没有设置文件路径和网络路径，则仅打开阅读器，不打开文件
     *     url:   阅读器打开的网络文件URL
     *     page: 打开文件的同时，调转到的页面
     *     disablePrint: 是否禁用打印，默认不禁用
     *     disableSign: 是否禁用签章，默认不禁用
     *     hideToolBar: 是否隐藏工具栏，默认不隐藏
     *     titleBarVisible: 是否显示标题栏，，默认贴合时不显示，不贴合时显示。
     *     titleMaxMinVisible: 是否显示标题栏最小化和最大化，默认贴合时不显示，不贴合时显示。
     *     leftDockVisible: 是否显示左侧停靠栏，默认显示
     *     leftNavigateVisible: 是否显示左侧导航栏，默认不显示
     *     moveable: 是否可以移动窗口，默认贴合时不可移动，不贴合时可移动。
     *     resizeable: 是否可以修改窗口大小，默认贴合时不可修改，不贴合时可修改。
     *     pos:  窗口定位
     *     success：function(readerId){}
     *     fail: function(e){}
     * }
     */
    Reader.prototype.openReader=function (param) {
        if(this.status === Reader.STATUS_OPENED){
            $m.util.fail(param,new Error("阅读器已打开,如果需要再次打开，请先关闭"))
            return
        } else if(this.status === Reader.STATUS_OPENING ){
            $m.util.fail(param,new Error("阅读器正在打开中"))
            return
        } else if(this.status === Reader.STATUS_CLOSING){
            $m.util.fail(param,new Error("阅读器正在关闭中，请稍后操作"))
            return
        }

        var that=this
        var p={
            success: function (readerId){
                that.status=Reader.STATUS_OPENED
                that.readerId=readerId
                if(that.divReaderContainer){
                    that._hideOpening(that.divReaderContainer)
                    if(that.pendingScroll!=null){
                        that.pendingScroll.readerId=that.readerId
                        var ps=that.pendingScroll
                        that.scroll(ps)
                        that.pendingScroll=null
                    }
                }
                $m.util.success(param,readerId)
            },
            fail:function (e){
                if(that.divReaderContainer) {
                    that._hideOpening(that.divReaderContainer)
                }
                that.status=Reader.STATUS_NOT_OPEN
                $m.util.fail(param,e)
            }
        }

        //设置打开后的窗口位置
        if(this.divReaderContainer) {
            //贴合到div，找到div的位置
            this.nAppletRunID = 1721;    // 开启贴合滚动
            var pos = this._getElementSrceenPosAndBrowserState(document.getElementById(this.divReaderContainer))
            p.pos = {
                x: pos.x,
                y: pos.y,
                width: pos.w,
                height: pos.h
            }

            p.titleBarVisible = param.titleBarVisible || false
            p.titleMaxMinVisible = param.titleMaxMinVisible || false
            p.moveable = param.moveable || false
            p.resizeable = param.resizeable || false

            $m.debug("[reader] get div pos x="+p.pos.x+",y="+p.pos.y+",width="+p.pos.width+",height="+p.pos.height)
            p.hideLoading=true  //隐藏打开进程窗口
            //在div中显示正在打开
            this._showOpening(this.divReaderContainer)
        }else{
            //不贴合
            if(param.pos){
                //设置了大小，则采用设置的大小
                p.pos = param.pos
            } else {
                //使用默认大小
                p.pos=null
            }

            p.titleBarVisible = param.titleBarVisible!==undefined? param.titleBarVisible : true
            p.titleMaxMinVisible = param.titleMaxMinVisible!==undefined? param.titleMaxMinVisible : true
            p.moveable = param.moveable!==undefined? param.moveable : true
            p.resizeable = param.resizeable!==undefined?param.resizeable : true
            p.hideLoading=false  //不隐藏打开进度窗口
        }

        p.leftNavigateVisible = param.leftNavigateVisible!==undefined? param.leftNavigateVisible : true

        $m.util.setAttrs(p,param,["file","url","page","disablePrint","disableSign","hideToolBar",
            "leftDockVisible"])

        this.status=Reader.STATUS_OPENING
        this.imp.openReader(p);
    };

    Reader.prototype._showOpening=function (container){
        document.getElementById(container).innerHTML=' <div style="text-align: center; margin-top: 10%">' +
            '<img src="data:image/gif;base64,'+loadingImg+'" style="width: 28px; height: 28px; padding-right: 7px;">' +
            '阅读器打开中，请稍后...' +
            '</div>'
    }

    Reader.prototype._hideOpening=function (container){
        document.getElementById(container).innerHTML=""
    }

    Reader.prototype._initListeners=function (){
        // 监听窗口显示、隐藏事件
        this._WrlVisibilityListener(true);
        // 监听窗口滚动事件
        this._WrlScrollListener(true);

        this._PageCloseListener();

        // 监听窗口大小改变事件，使滚动状况匹配
        var that=this
        $(window).resize(function () {
            that._WrlScrollApplet();
        });

        // 浏览器焦点变换
        $(window).focus(function(){
            that._PageFocusState(true);
            $m.debug("[reader] browser window focus");
        });
        $(window).blur(function(){
            that._PageFocusState(false);
            $m.debug("[reader] browser window blur");
        })

        // 定时检测事件
        that.timerScroll = setInterval(function () {
            if (that.nAppletRunID && that.divReaderContainer) {
                var divR = document.getElementById(that.divReaderContainer);
                if(divR !== null && divR !== undefined){
                    var infoPos = that._getElementPagePosition(divR);
                    if (infoPos.x === that.lastPos.x &&
                        infoPos.y === that.lastPos.y &&
                        infoPos.w === that.lastPos.w &&
                        infoPos.h === that.lastPos.h){

                    }else{
                        that._scroll(infoPos);
                        that.lastPos = infoPos;
                        $m.debug("[reader] timer scroll ",JSON.stringify(that.lastPos));
                    }
                }
            }
        }, 100);
    }

    Reader.prototype._getElementSrceenPosAndBrowserState=function (element) {
        var divRect = element.getBoundingClientRect();
        var x = divRect.left;
        var y = divRect.top;
        var w = divRect.width;
        var h = divRect.height;

        //浏览器是否最大化
        var isMax = (window.outerHeight === screen.availHeight && window.outerWidth === screen.availWidth);

        // window.innerHeight: W3C-不包括菜单栏、工具栏以及滚动条等的浏览器窗口高度
        // window.outerHeight: 整个浏览器窗口的高度
        var toolbarH = window.outerHeight - window.innerHeight;

        var diffH = isMax ? 0 : 5;  //非最大化时窗口最上面多出了几个像素
        y = y - diffH;
        //浏览器最大化与非最大时下面的值不同，需要将此偏差值计算进去
        var diffW = (window.outerWidth - window.innerWidth) / 2;
        x = x + diffW;

        var ratio = this._DetectZoom();
        if(ratio.browserRatio && ratio.windowsRatio){
            y = Math.ceil(screenTop + toolbarH + y * ratio.ratio);
            x = Math.ceil(screenLeft + x * ratio.ratio);
            w = Math.ceil(w * ratio.ratio);
            h = Math.ceil(h * ratio.ratio);
        } else {
            y = Math.ceil((screenTop + toolbarH + y) * ratio.ratio);
            x = Math.ceil((screenLeft + x) * ratio.ratio);
            w = Math.ceil(w * ratio.ratio);
            h = Math.ceil(h * ratio.ratio);
        }

        return { x: x, y: y, w: w, h: h, isMax: isMax };
    }

    Reader.prototype._getElementPagePosition=function (element){
        var posInfo = { x: 0, y: 0, w: 0, h: 0, isMax: false, nshow: 4 };
        if (element !== null && element !== undefined){
            var divRect = element.getBoundingClientRect();
            var x = divRect.left;
            var y = divRect.top;
            var w = divRect.width;
            var h = divRect.height;

            //浏览器是否最大化
            var isMax = (window.outerHeight === screen.availHeight && window.outerWidth === screen.availWidth);

            // window.innerHeight: W3C-不包括菜单栏、工具栏以及滚动条等的浏览器窗口高度
            // window.outerHeight: 整个浏览器窗口的高度
            var toolbarH = window.outerHeight - window.innerHeight;

            var diffH = isMax ? 0 : 5;  //非最大化时窗口最上面多出了几个像素
            y = y - diffH;
            //浏览器最大化与非最大时下面的值不同，需要将此偏差值计算进去
            var diffW = (window.outerWidth - window.innerWidth) / 2;
            x = x + diffW;

            var ratio = this._DetectZoom();
            if(ratio.browserRatio && ratio.windowsRatio){
                y = Math.ceil(screenTop + toolbarH + y * ratio.ratio);
                x = Math.ceil(screenLeft + x * ratio.ratio);
                w = Math.ceil(w * ratio.ratio);
                h = Math.ceil(h * ratio.ratio);
            } else {
                y = Math.ceil((screenTop + toolbarH + y) * ratio.ratio);
                x = Math.ceil((screenLeft + x) * ratio.ratio);
                w = Math.ceil(w * ratio.ratio);
                h = Math.ceil(h * ratio.ratio);
            }

            posInfo.x = x;
            posInfo.y = y;
            posInfo.w = w;
            posInfo.h = h;
            posInfo.isMax = isMax;
            posInfo.nshow = 4;
        }

        return posInfo;
    }

    Reader.prototype._DetectZoom=function () {
        var ratio = 0, screen = window.screen, ua = navigator.userAgent.toLowerCase();

        if (window.devicePixelRatio !== undefined) {
            ratio = window.devicePixelRatio;
            var r={
                ratio: ratio
            }
            if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
                r.browserRatio = window.outerWidth / window.innerWidth;
                r.windowsRatio = ratio / r.browserRatio;
            }
            return r
        }
        else if (~ua.indexOf('msie')) {
            if (screen.deviceXDPI && screen.logicalXDPI) {
                ratio = screen.deviceXDPI / screen.logicalXDPI;
                return {
                    ratio: ratio
                }
            }
        }
        else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
            ratio = window.outerWidth / window.innerWidth;
            return {
                ratio: ratio
            }
        }

        /*if (ratio) {
            ratio = Math.round(ratio * 100);
            ratio = ratio / 100;
        }*/

        return {
            ratio: 1
        }
    };

    //页面可见和不可见事件
    Reader.prototype._WrlVisibilityListener=function (AddEvent){
        var that=this;
        function PageVisibilityState() {
            if (that.nAppletRunID < 1 || !that.divReaderContainer)
                return;   // 未贴合

            // 控制程序显示、仅对当前网页内加载的程序
            var divR = document.getElementById(that.divReaderContainer);
            if(divR !== null && divR !== undefined){
                var infoPos = that._getElementPagePosition(divR);
                if (document.visibilityState === 'visible') {
                    /// 恢复显示
                    infoPos = that.lastPos;
                    infoPos.nshow = 4;
                    $m.debug("[reader] visibility visible :" + JSON.stringify(infoPos));
                }
                else if (document.visibilityState === 'hidden') {
                    /// 需要隐藏
                    infoPos.nshow = 8;
                    $m.debug("[reader] visibility hide :" + JSON.stringify(infoPos));
                }
                //调整阅读器显示和隐藏
                that._scroll(infoPos);
            }
        }

        if (this.bRunInCurrentPage) {
            if (AddEvent) {
                if (document.addEventListener)
                    document.addEventListener('visibilitychange', PageVisibilityState, false);
                else
                    document.attachEvent('onvisibilitychange', PageVisibilityState, false);
            }
            else {
                if (document.removeEventListener)
                    document.removeEventListener('visibilitychange', PageVisibilityState, false);
                else
                    document.detachEvent('onvisibilitychange', PageVisibilityState, false);
            }
        }
    }

    Reader.prototype._scroll=function (scrollData) {
        var pos = {
            x: scrollData.x,
            y: scrollData.y,
            width: scrollData.w,
            height: scrollData.h,
            show: scrollData.nshow
        };
        var p={
            readerId: this.readerId,
            pos: pos
        }
        if(this.status===Reader.STATUS_OPENING){
            this.pendingScroll=p    //打开中，不用刷新
        } else if(this.status===Reader.STATUS_OPENED && this.readerId!=="" ) {
            this.imp.scroll(p)
        }
    }

    Reader.prototype.scroll=function (param) {
        this.imp.scroll(param)
    }

    //页面关闭
    Reader.prototype._PageCloseListener=function (){
        var that=this
        function BeforePageUnload(){
            //页面关闭之前，关闭阅读器
            if(that.readerId!=="" && that.status===Reader.STATUS_OPENED){
                that.closeReader({
                    readerId: that.readerId,
                    success: function (){},
                    fail: function (e){},
                })
            }
        }

        if (window.addEventListener){
            window.addEventListener('beforeunload', BeforePageUnload)
        }else if(window.attachEvent){// 主要是为了兼容老的IE
            window.attachEvent('on' + 'beforeunload', BeforePageUnload)
        }else{
            window.onbeforeunload = BeforePageUnload
        }
    }

    //页面滚动
    Reader.prototype._WrlScrollListener=function (AddEvent) {
        var that=this
        function scrollFunc(e) {
            if (!that.nAppletRunID || !that.bRunInCurrentPage || !that.divReaderContainer)
                return;

            //相应的调整阅读器位置
            that._WrlScrollApplet();
        }

        if (!$m.util.isFirefox()) {
            if (AddEvent) {
                if (window.pageXOffset !== undefined)
                    document.onscroll = scrollFunc;
                else
                    window.onscroll = scrollFunc;
            }
        }
        else {
            if (AddEvent)
                document.addEventListener("scroll", scrollFunc, false);
            else
                document.removeEventListener("scroll", scrollFunc);
        }
    }

    Reader.prototype._WrlScrollApplet=function () {
        if (this.nAppletRunID || !this.divReaderContainer) {
            var divR = document.getElementById(this.divReaderContainer);
            var infoPos = this._getElementPagePosition(divR);
            this._scroll(infoPos);
            this.lastPos = infoPos;
            $m.debug("[reader] scroll:" + JSON.stringify(infoPos));
        }
    }

    Reader.prototype._PageFocusState=function (isFocus) {
        if (this.nAppletRunID < 1 || !this.divReaderContainer)
            return;// 未启动程序
        // 控制程序显示、仅对当前网页内加载的程序
        var divR = document.getElementById(this.divReaderContainer);
        if(divR !== null && divR !== undefined){
            var infoPos = this._getElementPagePosition(divR);
            if (isFocus) {
                /// 恢复显示
                if (this.lastPos != null || this.lastPos !== undefined)
                    infoPos = this.lastPos;
                infoPos.nshow = 4;
                $m.debug("[reader] page focus state isFocus=true show:" + JSON.stringify(infoPos));
            }
            else {
                /// 需要隐藏
                infoPos.nshow = 8;
                $m.debug("[reader] page focus state isFocus=false hide:" + JSON.stringify(infoPos));
            }
            this._scroll(infoPos);
        }
    }

    Reader.prototype.closeReader=function (param) {
        if(this.status === Reader.STATUS_NOT_OPEN){
            //已关闭,直接成功
            $m.util.success(param,null)
            return
        } else if(this.status === Reader.STATUS_OPENING ){
            $m.util.fail(param,new Error("阅读器正在打开中"))
            return
        } else if(this.status === Reader.STATUS_CLOSING){
            $m.util.fail(param,new Error("阅读器正在关闭中，请稍后操作"))
            return
        }

        var that=this
        var p={
            success: function (readerId){
                that.status=Reader.STATUS_NOT_OPEN
                $m.debug("[reader] "+that.readerId+" closed")
                that.readerId=""
                $m.util.success(param,null)
            },
            fail:function (e){
                $m.util.fail(param,e)
            }
        }
        $m.util.setAttrs(p,param,["readerId"])

        this.status=Reader.STATUS_CLOSING
        p.readerId=this.readerId
        this.imp.closeReader(p)
    }

    Reader.prototype.openFile=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.openFile(param)
    }

    Reader.prototype.closeFile=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.closeFile(param)
    }

    Reader.prototype.setSignButtons=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.setSignButtons(param)
    }

    Reader.prototype.setToolBar=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.setToolBar(param)
    }

    Reader.prototype.setRatio=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.setRatio(param)
    }

    Reader.prototype.getCurrentFileInfo=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.getCurrentFileInfo(param)
    }

    Reader.prototype.gotoPage=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.gotoPage(param)
    }

    Reader.prototype.getPage=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.getPage(param)
    }

    Reader.prototype.setTitleBar=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.setTitleBar(param)
    }

    Reader.prototype.setLeftBar=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.setLeftBar(param)
    }

    Reader.prototype.setMainWindow=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.setMainWindow(param)
    }

    Reader.prototype.triggerAction=function (param) {
        if(!this._assertOpenedStatus(param)){
            return
        }
        param.readerId=this.readerId
        this.imp.triggerAction(param)
    }

    Reader.prototype._assertOpenedStatus=function (param) {
        if(this.status === Reader.STATUS_NOT_OPEN){
            $m.util.fail(param,new Error("阅读器已关闭"))
            return false
        } else if(this.status === Reader.STATUS_OPENING ){
            $m.util.fail(param,new Error("阅读器正在打开中，请稍后操作"))
            return false
        } else if(this.status === Reader.STATUS_CLOSING){
            $m.util.fail(param,new Error("阅读器正在关闭中"))
            return false
        }

        return true
    }

    Reader.prototype.addEventListener=function(param){
        if(this.eventBus[param.name]){
            var find=false;
            for(var i=0;i<this.eventBus[param.name].length;i++){
                if(this.eventBus[param.name][i].callback===param.callback){
                    find=true;
                    break;
                }
            }
            if(!find){
                this.eventBus[param.name].push(param);
                return true;
            }
            else {
                return true;
            }
        }
        else{
            this.eventBus[param.name]=[];
            this.eventBus[param.name].push(param);
            return true;
        }
    };

    /**
     * 删除事件监听
     * @param param
     * {
     *     name: 事件名称
     *     callback:
     * }
     */
    Reader.prototype.removeEventListener=function (param) {
        if(this.eventBus[param.name]) {
            for(var i=0;i<this.eventBus[param.name].length;i++){
                if(this.eventBus[param.name][i].callback===param.callback){
                    this.eventBus[param.name].splice(i,1)
                    return true;
                }
            }

            return false;
        }
        else{
            return false;
        }
    };

    Reader.prototype._eventHandler=function(eventName,eventObject){
        $m.debug("event:",eventName,eventObject);

        if(this.readerId === "" || eventObject.readerId === this.readerId){
            if(this.eventBus[eventName]){
                for(var i=0;i<this.eventBus[eventName].length;i++){
                    if(this.eventBus[eventName][i].callback){
                        this.eventBus[eventName][i].callback(eventName,eventObject);
                    }
                }
            }

            if(eventName==="closeReader"){
                //用户主动关闭了阅读器
                this.status=Reader.STATUS_NOT_OPEN
                $m.debug("[reader] "+this.readerId+" closed by user(get a event closeReader)")
                this.readerId=""
            }
        }
    };

    $m.Reader=Reader;

})(HebcaMiddleware);
